import { createContext, type PropsWithChildren, useEffect, useState } from 'react'

import { CurrencyEnum } from '../types/enums/common/currency.enum'

type CurrencyContextType = {
  currency: CurrencyEnum
  setCurrency: (s: CurrencyEnum) => void
}

export const CurrencyContext = createContext<CurrencyContextType>({
  currency: CurrencyEnum.EUR,
  setCurrency: () => {}
})

type Props = {
  currency: CurrencyEnum
}

const CurrencyProvider = ({ children, currency }: PropsWithChildren<Props>) => {
  const [state, setState] = useState<CurrencyEnum>(currency)

  useEffect(() => {
    setState(currency)
  }, [currency])

  return (
    <CurrencyContext.Provider value={{ currency: state, setCurrency: setState }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export default CurrencyProvider
